import React, { useRef } from 'react'

import { Map } from 'leaflet';
import { MapContainer, TileLayer } from 'react-leaflet';
import "leaflet/dist/leaflet.css";
import ObjectMapContent from '../components/ObjectMapContent';

const ObjectMap = () => {
  const mapRef = useRef<Map | null>(null);
  return (
    <div className="relative">
      <MapContainer
        id="map"
        scrollWheelZoom
        doubleClickZoom={false}
        zoomControl={false}
        ref={mapRef}
        maxZoom={18}
        minZoom={7}
        className='mt-2'
        style={{ height: "69vh"}}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"

        />
        <ObjectMapContent />
      </MapContainer>
    </div>
  );
}

export default ObjectMap
